import { MsalAuthProvider, LoginType } from "react-aad-msal";

var redirectUri = "http://localhost:3000";
export var clientId = "344270c1-33b0-4781-8e6e-26881ab47124";
// var clientId = "2e608cf8-5da2-4a63-a594-9cc9564fe745";

if (process.env.REACT_APP_STAGE === "Dev") {
  redirectUri = "https://app-employee-portal-request-dev.azurewebsites.net";
}

if (process.env.REACT_APP_STAGE === "Test") {
  redirectUri = "https://app-employee-portal-request-tst.azurewebsites.net";
} 

else if (process.env.REACT_APP_STAGE === "Production") {
  clientId = "ab758eb6-29ee-4a2e-8363-5de9763a79db";
  redirectUri = "https://employee-request.hafnia.com";
}

const msalConfig = {
  auth: {
    authority:
      "https://login.microsoftonline.com/a364eb28-e95b-4ad0-a4fb-5b4f7767ad84",
    clientId: clientId,
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const authParameters = {
  // scopes: ["api://422132b5-d04c-4e43-a6db-6651f01a1109/Read"],
  scopes: ["api://583fded1-b0aa-48aa-ba5f-1417366c7d06/Read"],
};

const authOptions = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin,
};

export const authProvider = new MsalAuthProvider(
  msalConfig,
  authParameters,
  authOptions
);
